class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.unsubscribeCartUpdate = null;

    if (!this.notification) return;

    // Cerrar con Escape
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Botones de cierre (X y "seguir comprando")
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  connectedCallback() {
    // Suscribirnos SIEMPRE al evento global de actualización de carrito
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeCartUpdate = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        ({ data }) => {
          if (!data || !data.cartData) return;
          // Renderizamos la notificación con el estado más reciente del carrito
          this.renderContents(data.cartData);
        }
      );
    }
  }

  disconnectedCallback() {
    if (typeof this.unsubscribeCartUpdate === 'function') {
      this.unsubscribeCartUpdate();
      this.unsubscribeCartUpdate = null;
    }
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.activeElement) {
      removeTrapFocus(this.activeElement);
    } else {
      removeTrapFocus();
    }
  }

  renderContents(parsedState) {
    if (!parsedState) {
      // Si no hay estado, no hacemos nada más que mostrar lo que ya hubiera
      if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
      this.open();
      return;
    }

    this.cartItemKey = parsedState.key;

    // 1) Actualizar SOLO el contenido de la notificación (no el icono del carrito)
    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const html = parsedState.sections[section.id];
        if (!html) return;

        const innerHTML = this.getSectionInnerHTML(html, section.selector);
        if (!innerHTML) return;

        container.innerHTML = innerHTML;
      });
    }

    // 2) Actualizar el contador del carrito usando ÚNICAMENTE el item_count del estado retornado
    const itemCount =
      typeof parsedState.item_count === 'number'
        ? parsedState.item_count
        : (parsedState.cart && typeof parsedState.cart.item_count === 'number'
            ? parsedState.cart.item_count
            : null);

    if (itemCount !== null) {
      this.updateCartBubbleFromCount(itemCount);
    }

    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      // IMPORTANTE: NO incluimos 'cart-icon-bubble' aquí para que no se re-renderice desde secciones
    ];
  }

  /**
   * Actualiza el contador del icono del carrito usando un número concreto.
   * No hace fetch; depende solo de los datos del add-to-cart/cartUpdate.
   */
  updateCartBubbleFromCount(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (itemCount > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartIcon.appendChild(bubble);
      }

      // Limpiar contenido anterior
      bubble.innerHTML = '';

      // Span visible
      const visibleSpan = document.createElement('span');
      visibleSpan.setAttribute('aria-hidden', 'true');
      visibleSpan.textContent = itemCount < 100 ? itemCount : '99+';
      bubble.appendChild(visibleSpan);

      // Span accesible
      const srSpan = document.createElement('span');
      srSpan.className = 'visually-hidden';
      srSpan.textContent = `${itemCount} artículos en el carrito`;
      bubble.appendChild(srSpan);
    } else if (bubble) {
      bubble.remove();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const doc = new DOMParser().parseFromString(html, 'text/html');

    if (!selector) {
      return doc.body ? doc.body.innerHTML : null;
    }

    const selectedElement = doc.querySelector(selector);

    if (!selectedElement) {
      return doc.body ? doc.body.innerHTML : null;
    }

    return selectedElement.innerHTML;
  }

  handleBodyClick(evt) {
    if (!this.notification) return;

    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure', 'header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
